<template lang="html">

<div id="buildings">

      <el-row class="headLine">
           <el-col :span="12">产业空间信息（存量商务楼宇）</el-col>

      <!-- 编辑 -->
           <el-col :span="12" style="text-align:right;">
               <el-button @click="goInner" style="width:90px;" size="small" type="primary">新建</el-button>
               <el-button @click="reList" style="width:90px;" size="small">刷新</el-button>
           </el-col>

      </el-row>


      <BuildingList ref="buildingList" />

</div>

</template>

<script>
import BuildingList from './buildingList';
import { getBuildings } from '@/api/industryInfos';
export default {
    components:{
        BuildingList
    },
    data(){
        return{

        }
    },
    methods:{
        goInner(){
            this.$router.push('bulidingEdit');
        },
        reList(){
            this.$refs.buildingList.reList();
        }
    }

}
</script>

<style lang="scss" scoped>

#buildings{
    font-size: 15px;

    .headLine{
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #EBEEF5;
    }

    .seekLine{
        padding: 20px;
        padding-bottom: 0px;
        border-bottom: 1px solid #EBEEF5;
        .inpItem{
            padding-right: 20px;
            margin-bottom: 20px;
            .inpName{
                width: 120px;
                float: left;
                font-size: 14px;
                text-align: right;
                padding-top: 6px;
            }
            .inpContent{
                margin-left: 120px;
                .el-select{
                    display: block;
                }
            }
        }

    }

}

</style>

<style lang="scss">

#buildings{
    .el-input__inner{
        border-radius: 0px;
    }
    .dHead{
        background: #f5f5f5;
        font-weight: normal;
    }

}

</style>



// WEBPACK FOOTER //
// index.vue?2694afec